module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend"
  }, [_c('div', {
    staticClass: "gap"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('mu-tabs', [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "icon": "star",
      "title": "Morment",
      "iconClass": "ii-1",
      "titleClass": "t-1",
      "disabled": ""
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "icon": "location_on",
      "title": "Nearby",
      "iconClass": "ii-2",
      "titleClass": "t-1",
      "disabled": ""
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "icon": "terrain",
      "title": "Interest",
      "iconClass": "ii-3",
      "titleClass": "t-1",
      "disabled": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gap-1"
  }), _vm._v(" "), _c('mu-list', [_c('div', {
    staticClass: "item"
  }, [_c('mu-list-item', {
    attrs: {
      "title": "Live"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "videocam",
      "color": "#64dd17"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Video"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "video_library",
      "color": "#d84315"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Music"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "headset",
      "color": "#1976d2"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1)], 1)]), _vm._v(" "), _c('mu-list', [_c('div', {
    staticClass: "item"
  }, [_c('mu-list-item', {
    attrs: {
      "title": "Book"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "book",
      "color": "#1e88e5"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "News"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "whatshot",
      "color": "#ef6c00"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Game"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "videogame_asset",
      "color": "#00e5ff"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1)], 1)]), _vm._v(" "), _c('mu-list', [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        return _vm.handleMap()
      }
    }
  }, [_c('mu-list-item', {
    attrs: {
      "title": "Mucket"
    }
  }, [_c('mu-icon', {
    attrs: {
      "slot": "left",
      "value": "shopping_cart",
      "color": "#1e88e5"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon', {
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_right"
    },
    slot: "right"
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6365ae24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover/discover.vue
// module id = 515
// module chunks = 1